module.exports = __webpack_public_path__ + "img/img5.8a306988.png";